import { observer } from 'mobx-react'
import React, { FC, useContext } from 'react'
import {
  computeSeedAmountPerUnitArea,
  convertSqmToAreaByUnit,
  convertSqmToYieldByUnit,
  displayWeight,
  isPresent,
} from '../farmai-shared/LFUtils'
import { RootStoreContext } from '../stores/rootStore'
import { thousandSeparator } from '../services/utils'

export const LFNumber: FC<{
  num?: number | null
  unit?: string
  tooltip?: string
  underlined?: boolean
  format?:
    | 'area'
    | 'yield'
    | 'weight'
    | 'income'
    | 'cropQuality'
    | 'fertilizerAmount'
    | 'seedUsage'
  computed?: boolean
  denom?: number
  testId?: string
  className?: string
}> = observer(
  ({
    num,
    unit,
    format,
    denom,
    underlined,
    computed = false,
    testId,
    className = '',
    tooltip,
  }) => {
    const { userStore } = useContext(RootStoreContext)

    if (!isPresent(num)) return <p>-</p>
    const numeric = Number(num)
    const isNumericFinite = Number.isFinite(numeric)

    const convertor = {
      area: convertSqmToAreaByUnit(num, userStore.user.settings.area_unit, {
        computed: computed,
      }),
      yield: convertSqmToYieldByUnit(
        num * userStore.user.weightUnitFactor,
        userStore.user.settings.area_unit,
        { computed: computed }
      ),
      weight: displayWeight(num * userStore.user.weightUnitFactor, {
        computed: computed,
      }),
      income: num,
      // guard before calling toFixed:
      cropQuality: isNumericFinite ? numeric.toFixed(2) : undefined,
      fertilizerAmount: convertSqmToAreaByUnit(
        num,
        userStore.user.settings.area_unit
      ),
      seedUsage:
        computeSeedAmountPerUnitArea(
          Number(num) || 0,
          denom || 0,
          String(userStore.user.settings.area_unit)
        ) || 0,
    }

    const value = format ? convertor[format] : num
    return tooltip ? (
      <div
        data-tooltip-content={tooltip}
        data-tooltip-id={`mobile-enabled-stooltip`}
        className={`
          ${className ? className : ''}
          w-fit
        `}
      >
        <p
          className={`
            ${className ? className : ''}
            ${underlined ? 'underline decoration-dotted' : ''}
          `}
          data-testid={testId}
        >
          {thousandSeparator(value)} {unit}
        </p>
      </div>
    ) : (
      <p
        className={`
          ${className ? className : ''}
          ${underlined ? 'underline decoration-dotted' : ''}
        `}
        data-testid={testId}
      >
        {thousandSeparator(value)} {unit}
      </p>
    )
  }
)